var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55867 10.6512L10.6512 2.55867C11.3961 1.81378 12.6039 1.81378 13.3488 2.55867L17.2397 6.44963L20.4697 3.21967C20.7626 2.92678 21.2374 2.92678 21.5303 3.21967C21.8232 3.51256 21.8232 3.98744 21.5303 4.28033L18.3004 7.51029L21.4413 10.6512C22.1862 11.3961 22.1862 12.6039 21.4413 13.3488L13.3488 21.4413C12.6039 22.1862 11.3961 22.1862 10.6512 21.4413L2.55867 13.3488C1.81378 12.6039 1.81378 11.3961 2.55867 10.6512ZM17.2397 6.44963L12 11.6893L9.53033 9.21967C9.23744 8.92678 8.76256 8.92678 8.46967 9.21967C8.17678 9.51256 8.17678 9.98744 8.46967 10.2803L11.4697 13.2803C11.7626 13.5732 12.2374 13.5732 12.5303 13.2803L18.3004 7.51029L17.2397 6.44963Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVote);
export default __webpack_public_path__ + "static/media/vote.4578db4d56e1b97968a1eb89f62941c3.svg";
export { ForwardRef as ReactComponent };